import callApi from './storeMapService';
const basePath = '/frontend/api';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

export const getStores = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/v2/store/dropdown?${buildQueryUrlFromObject(storeInfo)}`,
});
